'use client'

import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { ReactSelectMenu } from '@repo/ui/ReactSelectMenu'
import { useKeyDateStore } from '@repo/store/useKeyDateStore'

export const KeyDateLocationSelect = ({
  testData = null,
  value = null,
  onChange = (val) => {
    console.log(val)
  },
  sx = {},
  size = 'small',
  label = 'Key Date Location',
  keyDateTable = false
}) => {
  const { keyDateLocations, fetchKeyDateLocations } = useKeyDateStore()
  const [options, setOptions] = useState(testData || keyDateLocations || [])
  const [dateHasBeenFetched, setDateHasBeenFetched] = useState(false)

  useEffect(() => {
    if (testData) return
    setOptions(keyDateLocations || [])
  }, [testData, keyDateLocations])

  useEffect(() => {
    if (testData || !keyDateLocations || keyDateLocations.length || dateHasBeenFetched) return
    fetchKeyDateLocations()
    setDateHasBeenFetched(true)
  }, [testData, fetchKeyDateLocations, keyDateLocations, dateHasBeenFetched])

  const KeyDateTableSx = keyDateTable
    ? {
        [`& > div > div`]: {
          backgroundColor: 'transparent',
          minHeight: 0,
          height: '33px',
          mt: '3px'
        },
        [`& .MuiInputLabel-shrink`]: {
          backgroundColor: '#f5f6f8 !important'
        },
        [`& > div > div > div`]: {
          height: '30px'
        }
      }
    : null

  return (
    <div data-testid="KeyDateLocationSelect" style={{ width: sx?.width || '100%', maxWidth: sx?.maxWidth || '100%' }}>
      <ReactSelectMenu
        label={label}
        onChange={onChange}
        labelKey="description"
        idLabelKey="keyDateLocationId"
        valueKey="keyDateLocationId"
        items={options}
        value={value}
        searchable
        size={size}
        name="keyDateLocationId"
        showIdInResults={false}
        disabled={!options?.length}
        menuZindex={9999999}
        sx={KeyDateTableSx}
      />
    </div>
  )
}

KeyDateLocationSelect.propTypes = {
  testData: PropTypes.array,
  value: PropTypes.object,
  onChange: PropTypes.func,
  sx: PropTypes.object,
  size: PropTypes.string,
  label: PropTypes.string,
  keyDateTable: PropTypes.bool
}
